var $         = require("jquery");

var FileSystemDocLoader = function(root, config) {
	var self = this;
    this.root = root;
    this.reader = new FileReader();

    $('body').prepend('<div id="filediv" style="height: 100px;"><input type="file" id="file" name="file" enctype="multipart/form-data" accept=".json" /></div>');
	$('#filediv').css({position: 'absolute', 'z-index':'99998'});
	$('#file').change(function(evt) {
        self.reader.readAsText(evt.target.files[0]);
    });
	// document.getElementById('file').addEventListener('change', function() {this.reader.readAsText(file);}, false);
};
module.exports = FileSystemDocLoader;

FileSystemDocLoader.prototype.openDocument = function(doc_options) {
    var self = this;
    return new Promise(function(resolve, reject) {
		self.reader.onload = function() {
			// console.log(this.result);
	    	resolve(this.result);
	    	$('#filediv').hide();
		};
		self.reader.onerror = reject;
		// reader.readAsText(new File([], doc_options.fileName));
    })
    .then(function(content) {
        self.root.header = {};
        self.root.header["assetId"] = 0;
        self.root.header["assetType"] = 0;
		var data = self.root.dejsonify(JSON.parse(content).body);
        self.root.attachData(data);
    });
};

FileSystemDocLoader.prototype.afterLoad = function() {
};
